import { FieldProps } from 'formik'
import {
  ChoiceGroup,
  IChoiceGroupOption,
  IChoiceGroupProps,
} from 'office-ui-fabric-react'
import * as React from 'react'

export type BooleanChoiceGroupProps = { fieldProps: FieldProps<any> } & Omit<
  IChoiceGroupProps,
  'options' | 'selectedKey'
> & {
    trueOption: IChoiceGroupOption
    falseOption: IChoiceGroupOption
    falseOptionFirst?: boolean
    horizontal?: boolean
  }

export const FormikBooleanChoiceGroup: React.FC<BooleanChoiceGroupProps> = ({
  fieldProps,
  trueOption,
  falseOption,
  falseOptionFirst,
  horizontal,
  ...props
}) => {
  const options = falseOptionFirst
    ? [falseOption, trueOption]
    : [trueOption, falseOption]

  if (horizontal) {
    falseOption.styles = { choiceFieldWrapper: { paddingRight: '10px' } }
    trueOption.styles = { choiceFieldWrapper: { paddingRight: '10px' } }
  }

  const selectedKey = fieldProps.field.value ? trueOption.key : falseOption.key

  return (
    <ChoiceGroup
      {...props}
      options={options}
      selectedKey={selectedKey}
      onChange={(_, option) => {
        if (option) {
          fieldProps.form.setFieldValue(
            fieldProps.field.name,
            option.key === trueOption.key
          )
        }
        if (props.onChange) {
          props.onChange(_, option)
        }
      }}
      styles={horizontal ? { flexContainer: { display: 'flex' } } : {}}
    />
  )
}
